import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { Button, SubTitle } from "./styles"
import { replenishmentService } from "services/replenishmentService"
import { toast } from "react-toastify"
import { ModalNoItems } from "components/ModalNoItems"
import { INewReplenishmentResponse } from "interfaces/IReplenishment"
import { useNavigate } from "react-router"
import { useAuth } from "hooks/useAuth"
import { enRules } from "interfaces/IUser"
import { workService } from "services/workService"

const Replenishment = () => {
  const [openNoItemsModal, setOpenNoItemsModal] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const {
    user: { rules },
  } = useAuth()
  const HasReplenisherPermission =
    rules.includes(enRules.ReplenishmentReplenisher) || rules.includes(enRules.Tech)
  const navigate = useNavigate()

  const handleWorkInProgressVerify = async () => {
    try {
      setisLoading(true)
      const response = await workService.getWorkInProgress()
      if (response?.results?.length > 0) {
        toast("Abastecimento em andamento encontrado.", { type: "success" })
        handleRecoveryReplenishment()
        return
      }
      setisLoading(false)
    } catch (error: any) {
      toast(
        error?.message ??
          "Ocorreu um erro ao verificar se existe abastecimento em aberto, dá um alô pro time de tech.",
        { type: "error" },
      )
      setisLoading(false)
    }
  }

  const handleRecoveryReplenishment = async () => {
    try {
      setisLoading(true)
      const response = await replenishmentService.getNewReplenishment()
      const replenishmentData: INewReplenishmentResponse = {
        workData: response?.workData,
        skuData: response?.skuData,
        replenishmentData: response?.replenishmentData,
        balanceData: response?.balanceData,
        suggestedQuantity: response?.suggestedQuantity,
      }
      if (response?.replenishmentData?.type === "stock_move") {
        navigate(`../sku/${response?.skuData?.sku}`, {
          state: { newReplenishment: replenishmentData },
        })
      } else {
        navigate(`../sku/${response?.skuData?.sku}/move`, {
          state: { newReplenishment: replenishmentData },
        })
      }
    } catch (error: any) {
      if (error?.message === "Não há itens necessitando abastecimento no momento.") {
        setOpenNoItemsModal(true)
        return
      }
      toast(error?.message ?? "Ocorreu um erro, dá um alô pro time de tech.", { type: "error" })
    } finally {
      setisLoading(false)
    }
  }

  const handleNewReplenishment = async () => {
    try {
      setisLoading(true)
      await replenishmentService.getNewReplenishment()
      const responsePooling = await replenishmentService.getNewReplenishmentVerify()
      const replenishmentData: INewReplenishmentResponse = {
        workData: responsePooling?.workData,
        skuData: responsePooling?.skuData,
        replenishmentData: responsePooling?.replenishmentData,
        balanceData: responsePooling?.balanceData,
        suggestedQuantity: responsePooling?.suggestedQuantity,
      }
      if (responsePooling?.replenishmentData?.type === "stock_move") {
        navigate(`../sku/${responsePooling?.skuData?.sku}`, {
          state: { newReplenishment: replenishmentData },
        })
      } else {
        navigate(`../sku/${responsePooling?.skuData?.sku}/move`, {
          state: { newReplenishment: replenishmentData },
        })
      }
    } catch (error: any) {
      if (error?.message === "Não há itens necessitando abastecimento no momento.") {
        setOpenNoItemsModal(true)
        return
      }
      toast(error?.message ?? "Ocorreu um erro, dá um alô pro time de tech.", { type: "error" })
    } finally {
      setisLoading(false)
    }
  }

  const handleNewEspecificSkuReplenishment = async () => {
    navigate("../sku/especific")
  }

  const handleNewSplitBoxReplenishment = async () => {
    navigate("../sku/split-box")
  }

  useEffect(() => {
    handleWorkInProgressVerify()
  }, [])

  return (
    <>
      <Box display="flex" justifyContent="center" flexDirection="column">
        <SubTitle style={{ marginTop: "1rem", textAlign: "center" }}>
          Opa, o que cê quer fazer agora? 🤠
        </SubTitle>
        <Button
          color="secondary"
          onClick={() => handleNewReplenishment()}
          disabled={isLoading || !HasReplenisherPermission}
          variant="contained"
          style={{ marginBottom: "3rem", marginTop: "3rem" }}
        >
          Atender demanda de reabastecimento
        </Button>
        <Button
          color="secondary"
          onClick={() => handleNewEspecificSkuReplenishment()}
          disabled={isLoading || !HasReplenisherPermission}
          variant="contained"
          style={{ marginBottom: "3rem" }}
        >
          Abastecer sku específico
        </Button>
        <Button
          color="secondary"
          onClick={() => handleNewSplitBoxReplenishment()}
          disabled={isLoading || !HasReplenisherPermission}
          variant="contained"
          style={{ marginBottom: "3rem" }}
        >
          Migrar sku
        </Button>
      </Box>
      <ModalNoItems
        open={openNoItemsModal}
        handleClose={() => {
          setOpenNoItemsModal(false)
        }}
      />
    </>
  )
}

export default Replenishment
